import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Users } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VisitorCounter() {
  const [count, setCount] = useState(null);
  const [shown, setShown] = useState(0);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    axios
      .post(`${API}/visitors/hit`)
      .then(({ data }) => setCount(data.count))
      .catch(() => axios.get(`${API}/visitors`).then(({ data }) => setCount(data.count)).catch(() => {}));
  }, []);

  useEffect(() => {
    if (count === null) return;
    const start = performance.now();
    const dur = 1200;
    let raf;
    const tick = (t) => {
      const p = Math.min((t - start) / dur, 1);
      setShown(Math.round(count * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [count]);

  if (count === null) return null;

  return (
    <span className="visitor-chip" data-testid="visitor-counter">
      <Users size={14} />
      <strong>{shown.toLocaleString("tr-TR")}</strong>
      <small>ziyaretçi</small>
    </span>
  );
}
